import React, { useState } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import "../../styles/aisprawl/aisprawl.css";
import "../../styles/ProfilesManager.css";

const VENDOR_LABELS = {
  openai: "OpenAI",
  azure: "Azure OpenAI",
  anthropic: "Anthropic",
  google: "Google",
  other: "Other",
};

export default function AisprawlConfig() {
  const [activeTab, setActiveTab] = useState("platform");
  const [isPlatformModalOpen, setIsPlatformModalOpen] = useState(false);
  const [editingPlatformId, setEditingPlatformId] = useState(null);
  const [platforms, setPlatforms] = useState([
    {
      id: 1,
      name: "crowdstrike",
      vendor: "Anthropic",
      apiEndpoint: "https://api.anthropic.com/v1/",
      apiKey: "",
    },
    {
      id: 2,
      name: "mde",
      vendor: "Azure OpenAI",
      apiEndpoint: "https://api.azure.com/v1/",
      apiKey: "",
    },
  ]);
  const [formVendor, setFormVendor] = useState("");
  const [formName, setFormName] = useState("");
  const [formEndpoint, setFormEndpoint] = useState("");
  const [formApiKey, setFormApiKey] = useState("");

  const resetForm = () => {
    setFormVendor("");
    setFormName("");
    setFormEndpoint("");
    setFormApiKey("");
  };

  const handleSavePlatform = () => {
    const vendorLabel = VENDOR_LABELS[formVendor] || formVendor || "—";
    const updated = {
      name: formName.trim() || "—",
      vendor: vendorLabel,
      apiEndpoint: formEndpoint.trim() || "—",
      apiKey: formApiKey.trim(),
    };

    if (editingPlatformId == null) {
      // Add new
      setPlatforms((prev) => [
        ...prev,
        {
          id: Date.now(),
          ...updated,
        },
      ]);
    } else {
      // Update existing
      setPlatforms((prev) =>
        prev.map((p) =>
          p.id === editingPlatformId
            ? {
              ...p,
              ...updated,
            }
            : p
        )
      );
    }

    resetForm();
    setEditingPlatformId(null);
    setIsPlatformModalOpen(false);
  };

  const handleDeletePlatform = (id) => {
    setPlatforms((prev) => prev.filter((p) => p.id !== id));
  };

  const openAddModal = () => {
    setEditingPlatformId(null);
    resetForm();
    setIsPlatformModalOpen(true);
  };

  const handleEditPlatform = (p) => {
    setEditingPlatformId(p.id);
    const vendorKey =
      Object.keys(VENDOR_LABELS).find((key) => VENDOR_LABELS[key] === p.vendor) ||
      "";
    setFormVendor(vendorKey);
    setFormName(p.name === "—" ? "" : p.name);
    setFormEndpoint(p.apiEndpoint === "—" ? "" : p.apiEndpoint);
    setFormApiKey(p.apiKey || "");
    setIsPlatformModalOpen(true);
  };

  return (
    <>
      <div className="aisprawl-config-tabs">
        <div className="tabs">
          <button
            type="button"
            className={activeTab === "platform" ? "active" : ""}
            onClick={() => setActiveTab("platform")}
          >
            Platform
          </button>
          <button
            type="button"
            className={activeTab === "action" ? "active" : ""}
            onClick={() => setActiveTab("action")}
          >
            Action for AI Apps
          </button>
        </div>

        <div className="aisprawl-config-tab-content">
          {activeTab === "platform" && (
            <>
              <div className="pm-header">
                <div className="pm-title-section">
                  <h1 className="pm-title">Platforms</h1>
                </div>
                <button
                  type="button"
                  className="pm-create-btn"
                  onClick={openAddModal}
                >
                  ADD
                </button>
              </div>
              <div className="pm-profile-table pm-profile-table--cols-4">
                <div className="pm-profile-table-header">
                  <div className="pm-profile-table-cell">Name</div>
                  <div className="pm-profile-table-cell">Vendor</div>
                  <div className="pm-profile-table-cell">Details</div>
                  <div className="pm-profile-table-cell">Actions</div>
                </div>
                <div className="pm-profile-table-body">
                  {platforms.length === 0 ? (
                    <div className="pm-profile-table-row">
                      <div className="pm-profile-table-cell"><div>—</div></div>
                      <div className="pm-profile-table-cell"><div>—</div></div>
                      <div className="pm-profile-table-cell"><div>—</div></div>
                      <div className="pm-profile-table-cell"><div>—</div></div>
                    </div>
                  ) : (
                    platforms.map((p) => (
                      <div key={p.id} className="pm-profile-table-row">
                        <div className="pm-profile-table-cell"><div>{p.name}</div></div>
                        <div className="pm-profile-table-cell"><div>{p.vendor}</div></div>
                        <div className="pm-profile-table-cell"><div>{p.apiEndpoint}</div></div>
                        <div className="pm-profile-table-cell">
                          <div className="pm-profile-action-buttons">
                            <button
                              type="button"
                              className="pm-action-btn pm-edit-btn"
                              onClick={() => handleEditPlatform(p)}
                              title="Edit"
                            >
                              <FaEdit size={14} />
                            </button>
                            <button
                              type="button"
                              className="pm-action-btn pm-delete-btn"
                              onClick={() => handleDeletePlatform(p.id)}
                              title="Delete"
                            >
                              <FaTrash size={14} />
                            </button>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </>
          )}
          {activeTab === "action" && (
            <></>
          )}
        </div>
      </div>

      {isPlatformModalOpen && activeTab === "platform" && (
        <div className="pm-modal-overlay">
          <div className="pm-modal pm-modal--profile-type aisprawl-platform-modal">
            <h2 className="pm-modal-title">
              {editingPlatformId == null ? "Add Platform" : "Edit Platform"}
            </h2>
            <div className="aisprawl-platform-form">
              <div className="aisprawl-form-field">
                <label className="aisprawl-form-label">Platform Vendor</label>
                <select
                  className="aisprawl-form-input aisprawl-form-select"
                  value={formVendor}
                  onChange={(e) => setFormVendor(e.target.value)}
                >
                  <option value="" disabled>Select a vendor</option>
                  <option value="openai">OpenAI</option>
                  <option value="azure">Azure OpenAI</option>
                  <option value="anthropic">Anthropic</option>
                  <option value="google">Google</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div className="aisprawl-form-field">
                <label className="aisprawl-form-label">Platform Name</label>
                <input
                  type="text"
                  className="aisprawl-form-input"
                  placeholder="e.g. crowdstrike"
                  value={formName}
                  onChange={(e) => setFormName(e.target.value)}
                />
              </div>

              <div className="aisprawl-form-field">
                <label className="aisprawl-form-label">API Endpoint</label>
                <input
                  type="text"
                  className="aisprawl-form-input"
                  placeholder="https://api.example.com/v1/endpoint"
                  value={formEndpoint}
                  onChange={(e) => setFormEndpoint(e.target.value)}
                />
              </div>

              <div className="aisprawl-form-field">
                <label className="aisprawl-form-label">API Key</label>
                <input
                  type="text"
                  className="aisprawl-form-input"
                  placeholder="Enter API key"
                  value={formApiKey}
                  onChange={(e) => setFormApiKey(e.target.value)}
                />
              </div>
            </div>

            <div className="pm-modal-actions">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSavePlatform}
              >
                Add
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  resetForm();
                  setEditingPlatformId(null);
                  setIsPlatformModalOpen(false);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
